<template>
  <Modal :hide-close="true" class="max-w-[400px]!">
    <button
      type="button"
      aria-label="Close"
      class="absolute top-2 right-2 z-10 hidden size-[22px] cursor-pointer items-center justify-center rounded-[6px] text-gray-500/50 transition hover:bg-gray-200/25 hover:text-gray-500 tablet-v:flex"
      @click="handleClose"
    >
      <CloseIcon class="size-[13px]" aria-hidden="true" />
    </button>

    <Modal.Title>Confirm your payment</Modal.Title>

    <Modal.Body>
      <PaymentSummary
        :lines="lines"
        :total="total"
        :payment-method="paymentMethod"
        :error="error"
        @change-payment="handleChangePayment"
      />
    </Modal.Body>

    <Modal.Footer layout="vertical">
      <Button
        variant="primary"
        :disabled="!paymentMethod"
        :loading="loading"
        @click="handlePay"
      >
        Agree and pay
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Modal, Button } from '@dacr/library'
import { CloseIcon } from '@dacr/icons'

import PaymentSummary, {
  type PaymentSummaryLine,
} from '@/shared/dialogs/billing/PaymentSummary.vue'
import {
  usePayReportCredits,
  type PayReportProduct,
} from '../usePayReportCredits'
import { formatNumber } from '@/shared/utils/number'

const props = defineProps<{
  product: PayReportProduct
  afterPurchase?: () => void
}>()

const {
  loading,
  error,
  paymentMethod,
  total,
  handleChangePayment,
  handlePay,
  handleChange,
  handleClose,
} = usePayReportCredits(props.product, props.afterPurchase)

const lines = computed<PaymentSummaryLine[]>(() => [
  {
    label: `${formatNumber(props.product.credits)} report${
      props.product.credits > 1 ? 's' : ''
    }`,
    actionLabel: 'Change',
    onAction: handleChange,
  },
])
</script>
